/** UI tokens and copy for the listing hero. Post records live in `../data/blog-posts.json`. */
export const BLOG_PAGE_SIZE = 6

export const BLOG_SERIF_HEADING_CLASS = '[font-family:var(--font-blog-serif),serif]' as const

export const BLOG_HERO_DESKTOP_H1_FONT = 'md:font-[Georgia,serif]' as const

export const BLOG_CATEGORY_BADGE_BG = '#FDC700' as const

export const BLOG_ACTIVE_PILL =
  'border-[#001F5F] bg-[#001F5F] text-white hover:bg-[#001845] hover:text-white'

export const BLOG_HERO_TITLE = 'Blogs & Insights' as const

export const BLOG_INTRO_MOBILE_LINES = [
  'Expert advice on car accessories,',
  'maintenance tips, and the latest trends in',
  'automotive care. Everything you need to',
  'keep your vehicle in top condition.',
] as const

export const BLOG_INTRO_MOBILE_FLUID = BLOG_INTRO_MOBILE_LINES.join(' ')

export const BLOG_INTRO_DESKTOP_LEAD =
  'Expert advice on car accessories, maintenance tips, and the latest trends in automotive care. Everything you need to keep your vehicle in top '

export const BLOG_INTRO_DESKTOP_TAIL = 'condition.'

export const BLOG_EMPTY_FILTER_MESSAGE =
  'No posts in this category yet. Try another filter.'
